import * as yup from 'yup'

const isValidXml = (value) => {
  if (!value) return true
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(value, 'text/xml')
    return !doc.querySelector('parsererror')
  } catch {
    return false
  }
}

const schema = (scim) =>
  yup.object().shape({
    samlProvider: yup.string().max(20).required(),
    name: yup.string().max(200).required(),
    domain: yup
      .string()
      .max(200)
      .required()
      .matches(
        /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'O domínio deve ser válido, como "dponet.com.br"',
      ),
    platform: yup.string().max(200).required('Selecione um tipo de plataforma'),
    metadataUrl: yup.string().when(['samlProvider', 'metadataInputType'], {
      is: (samlProvider, metadataInputType) =>
        samlProvider === 'zitadel' && metadataInputType === 'url',
      then: yup
        .string()
        .max(200)
        .required('A URL de metadata é obrigatória')
        .url()
        .protocol(
          ['https', 'http'],
          'A URL de metadata deve utilizar HTTP ou HTTPS',
        ),
      otherwise: yup.string().url().max(200),
    }),
    metadataXml: yup.string().when('metadataInputType', {
      is: 'xml_content',
      then: yup
        .string()
        .required('O conteúdo XML é obrigatório')
        .test('is-valid-xml', 'Deve ser um XML válido', isValidXml),
    }),
    assertionConsumerServiceUrl: yup.string().max(200),
    serviceProviderEntityId: yup.string().max(200),
    identityProviderEntityId: yup.string().max(200),
    redirectUrl: yup.string().url().max(200),
    scim: yup.boolean(),
    ...(scim && {
      scimToken: yup.string().max(200).required(),
    }),
  })

export default schema
